// @import dependencies
import React, { CSSProperties, ReactElement } from 'react'
import { IconContext } from 'react-icons';
import { FaFacebookF, FaLink, FaLinkedinIn, FaTwitter, FaWhatsapp } from 'react-icons/fa';
import { MdEmail, MdShare } from 'react-icons/md';
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
// @end dependencies

// @import components
// @end components

// @import types
// @end types

// @import services
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ShareModule.scss'
// @end styles

export type ShareModuleYPosition = 'dropdown' | 'dropup'

interface IShareModuleProps {
  share: string
  className?: string
  style?: CSSProperties
  id?: string
  networks?: TypeSocialNetworksShare[]
  icon?: ReactElement
  yPosition?: ShareModuleYPosition
}

type TypeSocialNetworksShare = 'facebook' | 'twitter' | 'linkedin' | 'email' | 'whatsapp'

const ShareModule: React.FC<IShareModuleProps> = ({
  share,
  className,
  icon,
  id,
  networks,
  style,
  yPosition = 'dropdown'
}) => {
  return(
    <div
      className={`share_module-layout ${className ? className : ''}`}
      style={style}
      id={id}
    >
      <div className={`${yPosition} share-content-module`}>
        <button className="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {icon ? icon : <MdShare className='share-module--icon'/>}
        </button>
        <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
          {!networks || networks.includes('facebook') ?
            <FacebookShareButton url={share}>
              <FaFacebookF className='icon-social-media-share' size="1.3rem"/>
            </FacebookShareButton>
          :null}
          {!networks || networks.includes('twitter') ?
            <TwitterShareButton url={share}>
              <FaTwitter className='icon-social-media-share' size="1.3rem"/>
            </TwitterShareButton>
          :null}
          {!networks || networks.includes('linkedin') ?
            <LinkedinShareButton url={share}>
              <FaLinkedinIn className='icon-social-media-share' size="1.3rem"/>
            </LinkedinShareButton>
          :null}
          {!networks || networks.includes('email') ?
            <EmailShareButton url={share}>
              <MdEmail className='icon-social-media-share' size="1.3rem"/>
            </EmailShareButton>
          :null}
          {!networks || networks.includes('whatsapp') ?
            <WhatsappShareButton url={share}>
              <FaWhatsapp className='icon-social-media-share' size="1.3rem"/>
            </WhatsappShareButton>
          :null}
        </div>
      </div>
    </div>
  );
}

export default ShareModule;
